
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// 引入Vant 4
import Vant from 'vant'
import 'vant/lib/index.css'

// 引入flexible进行rem适配
import 'lib-flexible/flexible'

// 在桌面端使用时，可以引入桌面端适配
import '@vant/touch-emulator'

// 引入全局样式
import './styles/index.css'

const app = createApp(App)

// 使用Vant
app.use(Vant)
app.use(router)
app.use(store)
app.mount('#app')
